import Moment from 'moment';

// Helper function to get date defaults with priority: sessionStorage -> URL params -> today
const getDateDefaults = () => {
  const today = new Date();
  const todayTime = today.getTime();
  
  // 1st priority: Check sessionStorage
  const sessionStart = window.sessionStorage?.getItem('dashboardStartDate');
  const sessionEnd = window.sessionStorage?.getItem('dashboardEndDate');
  
  if (sessionStart && sessionEnd) {
    const startDate = new Date(sessionStart);
    const endDate = new Date(sessionEnd);
    if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
      return {
        start: startDate.getTime(),
        end: endDate.getTime()
      };
    }
  }
  
  // 2nd priority: Check URL query params
  const urlParams = new URLSearchParams(window.location.search);
  const urlStart = urlParams.get('start');
  const urlEnd = urlParams.get('end');
  
  if (urlStart && urlEnd) {
    const startDate = new Moment(urlStart).toDate();
    const endDate = new Moment(urlEnd).toDate();
    if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
      return {
        start: startDate.getTime(),
        end: endDate.getTime()
      };
    }
  }
  
  // 3rd priority: Today's date
  return {
    start: todayTime,
    end: todayTime
  };
};

const defaultState = {
  start: new Date().getTime(),
  end: new Date().getTime(),
  selectedCanvasser: 0,
  selectedOffice: 0,
  selectedRoute: 0,
  selectedShift: 0,
  selectedScript: null,
  assignedSites: [],
  assignedTurfs: [],
};

const dashboardParams = (state = defaultState, action) => {
  switch (action.type) {
    case "RESET_DASHBOARD_PARAMS":
      return {
        ...state,
        ...{
          selectedCanvasser: 0,
          selectedOffice: 0,
          selectedRoute: 0,
          selectedShift: 0,
          selectedScript: null,
          assignedSites: [],
          assignedTurfs: [],
        },
      };
    case "SET_DASHBOARD_PARAM":
      // if (state.dashboard  === state.session.focusedCampaign)
      const newState = { ...state, ...action.data };
      
      // Save date changes to sessionStorage for session-level persistence
      if (action.data.start !== undefined || action.data.end !== undefined) {
        if (action.data.start !== undefined) {
          window.sessionStorage?.setItem('dashboardStartDate', new Date(action.data.start).toISOString());
        }
        if (action.data.end !== undefined) {
          window.sessionStorage?.setItem('dashboardEndDate', new Date(action.data.end).toISOString());
        }
      }
      
      return newState;
    case "SET_DASHBOARD_OPTIONS":
      const newOptionsState = { ...state, ...action.data };
      
      // Save date changes to sessionStorage for session-level persistence
      if (action.data.start !== undefined || action.data.end !== undefined) {
        if (action.data.start !== undefined) {
          window.sessionStorage?.setItem('dashboardStartDate', new Date(action.data.start).toISOString());
        }
        if (action.data.end !== undefined) {
          window.sessionStorage?.setItem('dashboardEndDate', new Date(action.data.end).toISOString());
        }
      }
      
      return newOptionsState;
    case "persist/REHYDRATE":
      // When state is rehydrated from localStorage, apply date priority logic
      if (action.payload && action.payload.dashboardParams) {
        const dateDefaults = getDateDefaults();
        return {
          ...action.payload.dashboardParams,
          start: dateDefaults.start,
          end: dateDefaults.end
        };
      }
      return state;

    default:
      return state;
  }
};

export default dashboardParams;
